import type { NextPage } from 'next';
import { NskHead } from '~/components/common/head/NskHead';
import { Page as Component } from '~/components/specifics/vendors/settings/surveys/new/Page';

export const PATH = '/vendors/settings/surveys/new';

const SurveySetting: NextPage = () => (
  <>
    <NskHead title="アンケート作成" />
    <Component />
  </>
);

export default SurveySetting;
